module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-bold-straight-3S6L5GRX.woff?23c3fe173e1cadadc8aef20f11566e8d";